// Offers don't expire unless an admin sets a date. The Offer model requires an
// expirationDate and every expiry check compares dates, so "never" is a far-future
// date. Keep in sync with NO_EXPIRY_DATE in server/features/offers/service.js.
export const NO_EXPIRY_DATE = new Date('2099-12-31T23:59:59Z');
